import React from 'react';

import { EHeadingSize } from '@domain/enums/components/EHeading';

import { DomPagamentos as DomPagamentosIcon } from '@profitfy/pakkun-icons';

import { useOtherGatewayIntegration } from '@helpers/hooks/pages/dashboard/integrationCenter/gateway/useOtherGatewayIntegration';
import { useTheme } from 'styled-components';

import IntegrateForm from '@components/Dashboard/IntegrationCenter/Sidemodal/Gateway/OtherGateway/IntegrateForm';
import SkeletonLoading from './SkeletonLoading';

import * as S from './styles';

const DomPagamentos: React.FC = () => {
  const theme = useTheme();

  const { isLoadingOtherGateways, otherGateways } = useOtherGatewayIntegration();

  if (isLoadingOtherGateways || Boolean(!otherGateways)) {
    return <SkeletonLoading />;
  }

  return (
    <S.Wrapper>
      <S.HeadingWrapper>
        <DomPagamentosIcon size={52} />
        <S.Heading type={EHeadingSize.H4}>Integração com Dom Pagamentos</S.Heading>
      </S.HeadingWrapper>

      <IntegrateForm gatewayName="Dompagamentos" gatewayId="dompagamentos" />
    </S.Wrapper>
  );
};

export default DomPagamentos;
